import { useState } from 'react';
// hooks
import { useSnackbar } from 'notistack';
// guards
import GuestGuard from '../guards/GuestGuard';
// components
import Page from '../components/Page';
import { Campo, classesEntrada, BotaoPrimario } from '../components/gps/Modal';

/* ============================================================================
   /gpshub - gerador da senha de acesso a partir da chave do dispositivo.

   Rota VIVA: o GuestGuard tem um caso especial para ela (`pathname != "/gpshub"`),
   ou seja, ela continua acessivel mesmo com sessao aberta. Nao e tela de template.

   Migracao para o visual novo (shadcn + Tailwind, tokens --gps-*):

   1. O calculo, a mensagem de aviso e o texto do resultado NAO mudaram.

   2. CODIGO MORTO REMOVIDO - o arquivo importava `capitalCase`, `NextLink`,
      `styled` + 8 componentes do MUI (Box, Card, Stack, Link, Alert, Tooltip,
      Container, Typography, IconButton), `PATH_AUTH`, `Logo`, `LoginForm`,
      `Iconify`, `useAuth`, `useResponsive` e declarava quatro `styled()`
      (RootStyle, HeaderStyle, SectionStyle*, ContentStyle) - NENHUM deles
      aparecia no JSX. Era a tela de login copiada e esvaziada. Junto saiu o
      `useAuth().method` e os `smUp`/`mdUp`, calculados e nunca lidos.

   3. DEFEITO DE ESTILO: o container usava `max-w-128`, classe que NAO EXISTE na
      escala do Tailwind (max-w vai por nomes: sm, md, ..., ou valor arbitrario).
      Classe inexistente nao gera erro nem CSS - a caixa ficava com a largura
      total do flex. Agora e `max-w-[32rem]`, que e o que se pretendia.

   4. DEFEITO DE ACESSIBILIDADE/USO: o rotulo do campo estava comentado (havia
      apenas `id="first_name"`, nome sobrando da copia), e o Enter no campo nao
      fazia nada porque o botao era `type="button"` fora de um form. Agora ha
      <label> ligado por `htmlFor` e um <form onSubmit>, entao Enter gera igual ao
      clique.

   5. As cores cruas do template (bg-gray-50/teal-100/blue-700, com variantes
      `dark:` que nunca ligavam porque o tema escuro aqui e `data-theme`, nao a
      classe `dark` do Tailwind) sairam para os tokens: superficie neutra, botao
      primario e resultado em `info-soft`. Era o outro motivo de a tela nao
      acompanhar o tema escuro do sistema.
   ============================================================================ */

export default function gpshub() {
  const [valor, setValor] = useState('');
  const [gerado, setGerado] = useState('');
  const [valorAnterior, setValorAnterior] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  function handleGerar() {
    if (!valor) {
      enqueueSnackbar(`Campo codigo está vazio!`, { variant: 'warning', style: { whiteSpace: 'pre-line' } });

      return;
    }

    const valorNumero = valor.replace(/\D/g, '');
    const calculo = Number(valorNumero) * 113 + Number(valorNumero) * 7 + 5;
    setValorAnterior(valor.toString());
    setGerado(calculo.toString());
    setValor('');
  }

  return (
    <GuestGuard>
      <Page title="Gerar codigo">
        <div className="flex min-h-screen w-full items-center justify-center bg-fundo p-4">
          <div className="w-full max-w-[32rem] rounded-lg border border-line bg-surface p-6 shadow-card">
            <div className="flex items-center gap-3">
              <img src="/images/gps_hub.png" alt="GPShub" className="h-10 w-10 flex-none object-contain" />
              <div className="min-w-0">
                <h1 className="text-[14px] font-extrabold leading-tight text-ink">Gerar senha de acesso</h1>
                <p className="text-[12px] leading-tight text-muted-foreground">
                  Informe a chave do dispositivo para obter a senha.
                </p>
              </div>
            </div>

            <form
              className="mt-5"
              onSubmit={(e) => {
                e.preventDefault();
                handleGerar();
              }}
            >
              {/* O Campo JA E um <label> e o input vai dentro dele, entao o vinculo
                  rotulo-campo e implicito e nao depende de htmlFor. O `id` fica so
                  como ancora estavel (o antigo era "first_name", nome sobrando da
                  copia da tela de login). */}
              <Campo rotulo="Chave de acesso" obrigatorio>
                <input
                  type="text"
                  id="chave-acesso"
                  value={valor}
                  onChange={(e) => setValor(e.target.value)}
                  className={classesEntrada}
                  placeholder="Digite o codigo"
                  autoComplete="off"
                />
              </Campo>

              <div className="mt-3 flex justify-end">
                <BotaoPrimario type="submit">Gerar</BotaoPrimario>
              </div>
            </form>

            {gerado && (
              // role="status" em vez de "alert": e um resultado esperado da acao,
              // nao um problema. `alert` interrompe o leitor de tela.
              <div role="status" className="mt-5 flex gap-3 rounded-lg border border-line bg-info-soft p-3">
                <span aria-hidden className="flex-none text-info">
                  <svg className="h-5 w-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                  </svg>
                </span>
                <p className="text-[12.5px] leading-snug text-ink">
                  Para a chave de acesso <strong className="tabular-nums tabular-nums">{valorAnterior}</strong> foi gerado
                  a senha <strong className="tabular-nums tabular-nums">{gerado}</strong>
                </p>
              </div>
            )}
          </div>
        </div>
      </Page>
    </GuestGuard>
  );
}
